import React from 'react'
import Logo from '../../assest/images/rexovms.png'
import LoginForm from '../../component/form/login/LoginForm'

export default function Login() {
    return (
        <>
            <div className='login_bg'>
                <div className="container h-100">
                    <div className="login-container row d-flexh-100 align-items-center" >
                        <div className="col-md-6">

                            <div className='text-start login_right p-5'>
                                <div className='mb-3' style={{
                                    // position: 'relative',
                                    // // top: '-89px',
                                    // height: '100px'
                                }} >
                                    {/* style={{ height: '70px' }} */}
                                    <img src={Logo} alt="" className='img-fluid logo-img' />
                                </div>

                                <div className='ms-2'>
                                    <h3 className='text-white'>Welcome to Rexo<br /> Visitor Management System</h3>
                                    <h6 className='mt-3'>Log in to manage visitor check-ins, digital badges, host notifications, and real-time activity logs.</h6>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6  p-5">
                            <div className='login-details'>
                                {/* <div className='text-center mb-3' style={{ height: '70px' }}>
                                    <img src={Logo} alt="" className='img-fluid logo-img' />
                                </div> */}
                                <div className='text-start login_text'>
                                    <h6>Welcome Back</h6>
                                    <h2 className='mt-3'>Login !</h2>
                                    <h5>Please Log into your account...</h5>
                                </div>

                                <LoginForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
